function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.5 16a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
  stroke: "currentColor",
  strokeWidth: 2
});

var SvgCircleCheckActiveBig = function SvgCircleCheckActiveBig(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='15' height='17' viewBox='0 0 15 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M6.5 16C10.6421 16 14 12.6421 14 8.5C14 4.35786 10.6421 1 6.5 1C2.35786 1 -1 4.35786 -1 8.5C-1 12.6421 2.35786 16 6.5 16Z' stroke='currentColor' stroke-width='2' /%3E %3C/svg%3E";
export { SvgCircleCheckActiveBig as ReactComponent };